import React, { useEffect, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Badge,
  TabContent,
  TabPane,
} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import ProductTypeCreate from "./ProductTypeCreate";
import Select from "react-select";
import ProductTypeEdit from "./ProductTypeEdit";
import {
  deleteHUIDs,
  getProductTypes,
} from "../../../helpers/urlConfig/apiFunctions";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DeleteComponent from "../../../Components/Common/deleteComponent/DeleteComponent";
import { dateChangerFunc, dateParser } from "../../../helpers/dateParser";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { documentTitle } from "../../../helpers/documentTitle";
import PairsModal from "./PairsModal";
import errorResponseHandler from "../../../helpers/errorResponseHandler";

const ProductTypeList = () => {
  const [modal_list, setmodal_list] = useState(false);
  const [modal_delete, setmodal_delete] = useState(false);
  const [edit_modal_list, set_edit_modal_list] = useState(false);
  const [deleteId, setDeleteProductTypeId] = useState(null);
  const [currentProductType, setCurrentProductType] = useState(null);
  const [productsType, setProductsType] = useState([]);
  const [pairs, setPairs] = useState("");
  const [uniqueStockID, setUniqueStockID] = useState("");
  const [pairs_modal_list, set_pairs_modal_list] = useState(false);
  const [activeTab, setActiveTab] = useState("available"); // State for active tab

  const [filters, setFilters] = useState({
    product_name: null,
    product_type_name: null,
    huid: null,
    gender: null,
    age: null,
    startDate: null,
    endDate: null,
  });

  const tog_list = () => setmodal_list(!modal_list);
  const tog_delete = () => setmodal_delete(!modal_delete);
  const tog_edit = () => set_edit_modal_list(!edit_modal_list);
  const tog_pairs = () => set_pairs_modal_list(!pairs_modal_list);

  documentTitle("Product Types");

  const fetchData = async () => {
    try {
      const response = await getProductTypes();
      if (response.statusCode === 200) {
        setProductsType(response.data);
      } else {
        errorResponseHandler(response);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onClickRemoveBtn = async (data) => {
    console.log("remove data", data);

    let huids = [];
    if (data.pairs === null) {
      huids.push(data.huid);
    } else {
      let pairsData = JSON.parse(data.pairs);
      pairsData.map((item) => huids.push(item.huid));
    }

    console.log("deleted huid", huids);

    const body = {
      huid: huids,
    };

    console.log("body", body);

    const deleteHUIDResponse = await deleteHUIDs(body);

    console.log("deleteHUIDResponse", deleteHUIDResponse);
    setDeleteProductTypeId(data);
    tog_delete();
  };

  const handleEditClick = (product) => {
    setCurrentProductType(product);
    set_edit_modal_list(true);
  };

  const handleFilterChange = (field, selectedOption) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: selectedOption ? selectedOption.value : null,
    }));
  };

  const getUniqueValues = (field) => {
    const values = productsType
      // added for filtering the products based on the active tab
      .filter((product) => {
        // Filter products based on the active tab
        if (activeTab === "ordered" && product.comments !== "Ordered")
          return false;
        if (activeTab === "available" && product.comments === "Ordered")
          return false;
        return true;
      })
      .flatMap((product) => {
        if (field === "huid") {
          if (product.huid) return product.huid;
          const parsedHUIDs = product.pairs ? JSON.parse(product.pairs) : [];
          return parsedHUIDs.map((item) => item.huid);
        }
        return product[field];
      })
      .filter(Boolean);

    return [...new Set(values)].map((value) => ({
      value,
      label: value,
    }));
  };

  const handleDateChange = (field, value) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value || null,
    }));
  };

  // Filter products based on tab and filters
  const filteredProductTypes = productsType.filter((product) => {
    const { startDate, endDate } = filters;

    // Tab-based filtering
    if (activeTab === "ordered" && product.comments !== "Ordered") return false;
    if (activeTab === "available" && product.comments === "Ordered")
      return false;

    const passesRegularFilters = Object.entries(filters)
      .filter(([field]) => !["startDate", "endDate"].includes(field))
      .every(([field, value]) => {
        if (!value) return true;
        if (field === "huid") {
          if (
            product.huid &&
            product.huid.toLowerCase() === value.toLowerCase()
          )
            return true;
          if (product.pairs) {
            const parsedHUIDs = JSON.parse(product.pairs);
            return parsedHUIDs.some(
              (item) => item.huid.toLowerCase() === value.toLowerCase()
            );
          }
          return false;
        }
        const productValue = product[field]?.toString().toLowerCase();
        return productValue === value.toLowerCase();
      });

    if (!passesRegularFilters) return false;

    const productDateStr = dateParser(product.created_at);
    if (startDate && productDateStr < startDate) return false;
    if (endDate && productDateStr > endDate) return false;

    return true;
  });

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(filteredProductTypes);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Stock");
    XLSX.writeFile(workbook, `Stocks_${activeTab}.xlsx`);
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.text(
      `Stock List - ${activeTab.charAt(0).toUpperCase() + activeTab.slice(1)}`,
      14,
      10
    );
    doc.autoTable({
      head: [
        [
          "SL.No",
          "Product Name",
          "Product Type Name",
          "HUID",
          "Gram",
          "Gender",
          "Age",
          "Stock",
        ],
      ],
      body: filteredProductTypes.map((customer, index) => [
        index + 1,
        customer.product_name,
        customer.product_type_name,
        customer.huid,
        customer.gram,
        customer.gender,
        customer.age,
        customer.stock,
      ]),
    });
    doc.save(`Stocks_${activeTab}.pdf`);
  };

  const selectedPairs = (data, uniqueStockID) => {
    setPairs(data);
    setUniqueStockID(uniqueStockID);
    tog_pairs();
  };

  let pairCount = 0;

  const getHUIDs = (productTypes) => {
    let pairedHUIDs = [];
    if (productTypes.huid === null) {
      const parsedHUIDs = JSON.parse(productTypes.pairs);
      pairCount = parsedHUIDs.length;
      parsedHUIDs.map((item) => pairedHUIDs.push(item.huid));
      return pairedHUIDs.map((huid, index) => (
        <span
          key={index}
          style={{ fontSize: "10px" }}
          className="badge bg-danger me-1"
        >
          {huid}
        </span>
      ));
    } else {
      return <span className="badge bg-success">{productTypes.huid}</span>;
    }
  };

  const clearDateFilters = () => {
    setFilters((prev) => ({
      ...prev,
      startDate: null,
      endDate: null,
    }));
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb
            title="With HUID Stocks"
            pageTitle="With HUID Stocks"
            exportToExcel={exportToExcel}
            exportToPDF={exportToPDF}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id="customerList">
                    <Row className="g-2 mb-3 d-flex flex-wrap align-items-center">
                      <Col xs="auto">
                        <Button
                          color="success"
                          className="add-btn"
                          onClick={tog_list}
                          id="create-btn"
                        >
                          <i className="ri-add-line align-bottom me-1"></i>
                        </Button>
                      </Col>

                      {[
                        "product_name",
                        "huid",
                        "product_type_name",
                        "shop_name",
                      ].map((field) => (
                        <Col xs="auto" md="2" gap="1" key={field}>
                          <Select
                            options={getUniqueValues(field)}
                            isClearable
                            value={
                              filters[field]
                                ? {
                                    value: filters[field],
                                    label: filters[field],
                                  }
                                : null
                            }
                            onChange={(selectedOption) =>
                              handleFilterChange(field, selectedOption)
                            }
                            placeholder={`${field.replace("_", " ")}`}
                          />
                        </Col>
                      ))}

                      <Col
                        xs="auto"
                        md="2"
                        className="d-flex gap-1"
                        style={{ maxWidth: "12.5%" }}
                      >
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Start Date"
                          value={filters.startDate || ""}
                          onChange={(e) =>
                            handleDateChange("startDate", e.target.value)
                          }
                        />
                        <input
                          type="date"
                          className="form-control"
                          placeholder="End Date"
                          value={filters.endDate || ""}
                          onChange={(e) =>
                            handleDateChange("endDate", e.target.value)
                          }
                        />
                        <Button
                          color="secondary"
                          className="btn-sm"
                          onClick={clearDateFilters}
                          disabled={!filters.startDate && !filters.endDate} // Disable if no dates are selected
                        >
                          Clear
                        </Button>
                      </Col>
                    </Row>

                    {/* Tab Content */}
                    <TabContent activeTab={activeTab}>
                      <TabPane tabId="available">
                        <div className="table-responsive table-card mt-3 mb-1">
                          <table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr>
                                <th>SL.No</th>
                                <th>Tag ID</th>
                                <th>Product</th>
                                <th>Type</th>
                                <th>Model</th>
                                <th>HUID</th>
                                <th>Sets</th>
                                <th>Quantity</th>
                                <th>Weight</th>
                                <th>Status</th>
                                <th>Stock Type</th>
                                <th>Shop Name</th>
                                <th>Purchase Date</th>
                                <th>Created At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredProductTypes.map((products, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{products.unique_stock_id || "-"}</td>
                                  <td>{products.product_name || "-"}</td>
                                  <td>{products.product_type_name || "-"}</td>
                                  <td>{products.model_name || "-"}</td>
                                  <td>{getHUIDs(products)}</td>
                                  <td>
                                    {products.huid == null ? (
                                      <button
                                        onClick={() =>
                                          selectedPairs(
                                            products.pairs,
                                            products.unique_stock_id
                                          )
                                        }
                                      >
                                        Sets - {pairCount}
                                      </button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {products.stock <= 1 ? (
                                      <span className="badge bg-danger">
                                        {products.stock}
                                      </span>
                                    ) : (
                                      <span className="badge bg-success">
                                        {products.stock || "-"}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {products.gram <= 1 ? (
                                      <span className="badge bg-danger">
                                        {products.gram}
                                      </span>
                                    ) : (
                                      <span className="badge bg-success">
                                        {products.gram}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {(products.comments && (
                                      <span className="badge bg-danger">
                                        {products.comments}
                                      </span>
                                    )) || (
                                      <span className="badge bg-success">
                                        {"Available"}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {products.stock_type ===
                                    "Store Inventory" ? (
                                      <Badge color="primary" pill>
                                        {/* {products.stock_type} */}
                                        {"Own Stocks"}
                                      </Badge>
                                    ) : (
                                      <Badge color="info" pill>
                                        {"Other Stocks"}
                                      </Badge>
                                    )}
                                  </td>
                                  <td>{products.shop_name || "-"}</td>
                                  <td>
                                    {products.purchase_date != null &&
                                    products.purchase_date != ""
                                      ? dateChangerFunc(products.purchase_date)
                                      : "-"}
                                  </td>
                                  <td>
                                    {dateChangerFunc(
                                      dateParser(products.created_at)
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      {products.stock_type ===
                                      "Incoming Stock" ? (
                                        <div className="edit">
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() =>
                                              handleEditClick(products)
                                            }
                                          >
                                            Edit
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {products.comments !== "Ordered" && (
                                        <div className="remove">
                                          <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                              onClickRemoveBtn(products)
                                            }
                                          >
                                            {products.stock_type ===
                                            "Store Inventory"
                                              ? "Return"
                                              : "Remove"}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {filteredProductTypes.length === 0 && (
                            <div className="text-center mt-4">
                              <p>No Available Stocks found.</p>
                            </div>
                          )}
                        </div>
                      </TabPane>

                      <TabPane tabId="ordered">
                        <div className="table-responsive table-card mt-3 mb-1">
                          <table className="table align-middle table-nowrap">
                            <thead className="table-light">
                              <tr>
                                <th>SL.No</th>
                                <th>Tag ID</th>
                                <th>Product</th>
                                <th>Type</th>
                                <th>Model</th>
                                <th>HUID</th>
                                <th>Sets</th>
                                <th>Quantity</th>
                                <th>Weight</th>
                                <th>Status</th>
                                <th>Stock Type</th>
                                <th>Shop Name</th>
                                <th>Purchase Date</th>
                                <th>Created At</th>
                                <th>Action</th>
                              </tr>
                            </thead>
                            <tbody>
                              {filteredProductTypes.map((products, index) => (
                                <tr key={index}>
                                  <td>{index + 1}</td>
                                  <td>{products.unique_stock_id || "-"}</td>
                                  <td>{products.product_name || "-"}</td>
                                  <td>{products.product_type_name || "-"}</td>
                                  <td>{products.model_name || "-"}</td>
                                  <td>{getHUIDs(products)}</td>
                                  <td>
                                    {products.huid == null ? (
                                      <button
                                        onClick={() =>
                                          selectedPairs(
                                            products.pairs,
                                            products.unique_stock_id
                                          )
                                        }
                                      >
                                        Sets - {pairCount}
                                      </button>
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td>
                                    {products.stock <= 1 ? (
                                      <span className="badge bg-danger">
                                        {products.stock}
                                      </span>
                                    ) : (
                                      <span className="badge bg-success">
                                        {products.comments || "-"}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {products.gram <= 1 ? (
                                      <span className="badge bg-danger">
                                        {products.gram}
                                      </span>
                                    ) : (
                                      <span className="badge bg-success">
                                        {products.gram}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {(products.comments && (
                                      <span className="badge bg-danger">
                                        {products.comments}
                                      </span>
                                    )) || (
                                      <span className="badge bg-success">
                                        {"Available"}
                                      </span>
                                    )}
                                  </td>
                                  <td>
                                    {products.stock_type ===
                                    "Store Inventory" ? (
                                      <Badge color="primary" pill>
                                        {"Own Stocks"}
                                      </Badge>
                                    ) : (
                                      <Badge color="info" pill>
                                        {"Other Stocks"}
                                      </Badge>
                                    )}
                                  </td>
                                  <td>{products.shop_name || "-"}</td>
                                  <td>
                                    {products.purchase_date !== null
                                      ? dateChangerFunc(products.purchase_date)
                                      : "-"}
                                  </td>
                                  <td>
                                    {" "}
                                    {dateChangerFunc(
                                      dateParser(products.created_at)
                                    )}
                                  </td>
                                  <td>
                                    <div className="d-flex gap-2">
                                      {products.stock_type ===
                                        "Incoming Stock" &&
                                      products.comments !== "Ordered" ? (
                                        <div className="edit">
                                          <button
                                            className="btn btn-sm btn-success"
                                            onClick={() =>
                                              handleEditClick(products)
                                            }
                                          >
                                            Edit
                                          </button>
                                        </div>
                                      ) : (
                                        ""
                                      )}
                                      {products.comments !== "Ordered" && (
                                        <div className="remove">
                                          <button
                                            className="btn btn-sm btn-danger"
                                            onClick={() =>
                                              onClickRemoveBtn(products)
                                            }
                                          >
                                            {products.stock_type ===
                                            "Store Inventory"
                                              ? "Return"
                                              : "Remove"}
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                          {filteredProductTypes.length === 0 && (
                            <div className="text-center mt-4">
                              <p>No Ordered Stocks found.</p>
                            </div>
                          )}
                        </div>
                      </TabPane>
                    </TabContent>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <ProductTypeCreate
        modal_list={modal_list}
        setmodal_list={setmodal_list}
        tog_list={tog_list}
        fetchData={fetchData}
      />

      {pairs_modal_list && (
        <PairsModal
          pairs={pairs}
          uniqueStockID={uniqueStockID}
          pairs_modal_list={pairs_modal_list}
          tog_pairs={tog_pairs}
          fetchData={fetchData}
        />
      )}

      {edit_modal_list && (
        <ProductTypeEdit
          modal_list={edit_modal_list}
          setmodal_list={set_edit_modal_list}
          tog_list={tog_edit}
          fetchData={fetchData}
          currentProductType={currentProductType}
        />
      )}

      <DeleteComponent
        modal_delete={modal_delete}
        tog_delete={tog_delete}
        fetchData={fetchData}
        deleteId={deleteId}
        keyName="ProductType"
      />

      <ToastContainer />
    </React.Fragment>
  );
};

export default ProductTypeList;
